import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { api } from '../lib/api';
import { useAuth } from '../lib/auth';

/**
 * Records every public and signed-in page view. Failures are ignored so a
 * tracking outage never blocks using the app.
 */
export function AnalyticsTracker() {
  const location = useLocation();
  const { user, loading } = useAuth();
  const last = useRef('');

  useEffect(() => {
    if (loading) return;
    const path = `${location.pathname}${location.search}` || '/';
    const key = `${path}|${user?.id ?? ''}`;
    if (last.current === key) return;
    last.current = key;

    const payload = {
      path,
      referrer: document.referrer || null,
      language: navigator.language || null,
      screen: `${window.screen.width}×${window.screen.height}`,
    };
    void api.analyticsVisit(payload).catch(() => undefined);
  }, [location.pathname, location.search, loading, user?.id]);

  return null;
}
